<app-side-menu>
<!-- Modo de Visualização -->
<div *ngIf="isViewMode" class="checklist-view-container">
  <!-- Loading State -->
  <app-loading [show]="isLoading" message="Carregando checklist..."></app-loading>

  <!-- Error State -->
  <div *ngIf="!isLoading && !checklistDetail" class="alert alert-danger">
    <i class="fas fa-exclamation-circle"></i> Erro ao carregar checklist. Tente novamente.
  </div>

  <!-- Checklist Details -->
  <div *ngIf="!isLoading && checklistDetail">
  <div class="view-header">
    <div class="view-header-main">
      <h2><i class="fas fa-clipboard-list"></i> Checklist #{{ checklistDetail.Id }}</h2>
      <p class="view-header-subtitle">{{ checklistDetail.ChecklistSubType || checklistDetail.ChecklistType }}</p>
    </div>
    <div class="view-header-end">
      <div class="status-chip" [ngClass]="getStatusChipClass(checklistDetail.Status)">
        <i class="fas" [ngClass]="getStatusIcon(checklistDetail.Status)"></i>
        <div class="status-chip-text">
          <span class="status-chip-label">Status</span>
          <span class="status-chip-value">{{ formatStatus(checklistDetail.Status) }}</span>
        </div>
      </div>
      <div class="view-actions">
        <button
          *ngIf="checklistDetail && canCancelChecklistFromView()"
          type="button"
          class="btn btn-cancel-checklist"
          [disabled]="isCancellingChecklist"
          (click)="cancelChecklistFromView()">
          <i class="fas" [class.fa-ban]="!isCancellingChecklist" [class.fa-spinner]="isCancellingChecklist" [class.fa-spin]="isCancellingChecklist"></i>
          {{ isCancellingChecklist ? 'Cancelando...' : 'Cancelar checklist' }}
        </button>
        <button class="btn btn-secondary" (click)="navigateBack()">
          <i class="fas fa-arrow-left"></i> Voltar
        </button>
      </div>
    </div>
  </div>

  <!-- Resumo -->
  <div class="card mb-3 info-card">
    <h3><i class="fas fa-info-circle"></i> Resumo</h3>
    <div class="info-grid info-grid--compact">
      <div class="info-item">
        <div class="info-label"><i class="fas fa-tag"></i> Tipo</div>
        <div class="info-value">{{ checklistDetail.ChecklistType }}</div>
      </div>
      <div class="info-item">
        <div class="info-label"><i class="fas fa-building"></i> Setor</div>
        <div class="info-value">{{ checklistDetail.Sector }}</div>
      </div>
      <div class="info-item">
        <div class="info-label"><i class="fas fa-calendar-alt"></i> Registrado em</div>
        <div class="info-value">{{ formatDateTime(checklistDetail.ChecklistDate) }}</div>
      </div>
      <div class="info-item info-item--highlight" *ngIf="getPlateFromItems(checklistDetail)">
        <div class="info-label"><i class="fas fa-motorcycle"></i> Placa</div>
        <div class="info-value info-value--plate">{{ getPlateFromItems(checklistDetail) }}</div>
      </div>
    </div>
  </div>

  <!-- Sections -->
  <div class="sections-container">
    <div *ngFor="let section of getUniqueSections(checklistDetail.Sections)" class="card mb-3 section-card">
      <div class="section-header">
        <div class="section-header-title">
          <span class="section-letter">{{ getSectionLetter(section.OrderIndex) }}</span>
          <div class="section-title-text">
            <h4>
              <i class="fas" [ngClass]="getSectionIcon(section)"></i>
              {{ section.SectionName }}
            </h4>
          </div>
        </div>
      </div>

      <!-- Items da Section -->
      <div class="section-items" *ngIf="section.Items && section.Items.length > 0">
        <!-- Layout para Photos -->
        <div *ngIf="section.SectionType === 'Photos'" class="photos-grid-view">
          <!-- Fotos por Lado (OrderIndex 4) -->
          <div *ngIf="section.OrderIndex === 4" class="photos-required-container">
            <div class="photos-required-grid">
              <div *ngFor="let item of getValidItems(section.Items)" class="photo-item-card">
                <div class="photo-header">
                  <h5><i class="fas fa-camera"></i> {{ item.ItemName || 'Foto' }}</h5>
                </div>
                <div class="photo-content" *ngIf="item.PhotoUrl">
                  <img [src]="item.PhotoUrl" 
                       alt="{{ item.ItemName }}" 
                       class="checklist-photo-large" 
                       (click)="openImageModal(item.PhotoUrl!)">
                  <div class="photo-info">
                    <small *ngIf="item.PhotoSide">
                      <i class="fas fa-map-marker-alt"></i> Lado: {{ mapPhotoSide(item.PhotoSide) }}
                    </small>
                    <small *ngIf="item.Observations" class="d-block mt-1">
                      <i class="fas fa-comment"></i> {{ item.Observations }}
                    </small>
                  </div>
                </div>
                <div class="photo-placeholder" *ngIf="!item.PhotoUrl">
                  <i class="fas fa-image"></i>
                  <span>Foto não disponível</span>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Fotos Detalhadas (OrderIndex 5) -->
          <div *ngIf="section.OrderIndex === 5" class="photos-detail-container">
            <h5 class="section-subtitle"><i class="fas fa-images"></i> Fotos Detalhadas</h5>
            <div *ngIf="getValidItems(section.Items).length > 0; else noDetailPhotos" class="detail-photos-container">
              <div *ngFor="let item of getValidItems(section.Items)" class="photo-detail-card">
                <div class="photo-header">
                  <div class="photo-title-section">
                    <h6><i class="fas fa-camera-retro"></i> {{ item.ItemName || 'Foto Detalhada' }}</h6>
                    <span class="badge photo-side-badge" *ngIf="item.PhotoSide">
                      <i class="fas fa-map-marker-alt"></i> {{ mapPhotoSide(item.PhotoSide) }}
                    </span>
                  </div>
                </div>
                <div class="photo-content" *ngIf="item.PhotoUrl">
                  <img [src]="item.PhotoUrl" 
                       alt="{{ item.ItemName }}" 
                       class="checklist-photo-detail" 
                       (click)="openImageModal(item.PhotoUrl!)">
                  <div class="photo-info">
                    <div class="photo-condition-tag" *ngIf="item.Condition">
                      <span class="badge" 
                            [class.badge-success]="item.Condition === 'Bom'"
                            [class.badge-warning]="item.Condition === 'Médio' || item.Condition === 'Ruim'"
                            [class.badge-danger]="item.Condition === 'Danificado' || item.Condition === 'Faltando'"
                            [class.badge-info]="!['Bom', 'Médio', 'Ruim', 'Danificado', 'Faltando'].includes(item.Condition)">
                        <i class="fas fa-tag"></i> {{ item.Condition }}
                      </span>
                    </div>
                    <small *ngIf="item.Observations" class="d-block mt-1">
                      <i class="fas fa-comment"></i> {{ item.Observations }}
                    </small>
                  </div>
                </div>
                <div class="photo-placeholder" *ngIf="!item.PhotoUrl">
                  <i class="fas fa-image"></i>
                  <span>Foto não disponível</span>
                </div>
              </div>
            </div>
            <ng-template #noDetailPhotos>
              <div class="empty-detail-photos">
                <i class="fas fa-image"></i>
                <p>Nenhuma foto detalhada adicionada</p>
              </div>
            </ng-template>
          </div>
        </div>

        <!-- Layout para Accessories -->
        <div *ngIf="section.SectionType === 'Accessories'" class="accessories-grid-view">
          <div *ngIf="getValidItems(section.Items).length > 0; else noAccessories" class="accessories-container">
            <div *ngFor="let group of getAccessoryViewGroups(section.Items)" class="accessory-view-group">
            <h5 class="section-subtitle"><i class="fas fa-tools"></i> {{ group.title }}</h5>
            <div class="accessories-grid">
              <div *ngFor="let item of group.items" class="accessory-item-card">
                <div class="accessory-header">
                  <div class="accessory-name">
                    <i class="fas fa-cog text-muted"></i>
                    {{ item.ItemName || 'Acessório/Equipamento' }}
                  </div>
                  <div class="accessory-condition-tag" *ngIf="item.Condition">
                    <span class="badge" 
                          [class.badge-success]="item.Condition === 'Bom'"
                          [class.badge-warning]="item.Condition === 'Médio' || item.Condition === 'Ruim'"
                          [class.badge-danger]="item.Condition === 'Danificado' || item.Condition === 'Faltando'"
                          [class.badge-info]="!['Bom', 'Médio', 'Ruim', 'Danificado', 'Faltando'].includes(item.Condition)">
                      <i class="fas fa-tag"></i> {{ item.Condition }}
                    </span>
                  </div>
                </div>
                <div class="accessory-photo" *ngIf="item.PhotoUrl">
                  <img [src]="item.PhotoUrl" 
                       alt="{{ item.ItemName }}" 
                       class="accessory-photo-thumb" 
                       (click)="openImageModal(item.PhotoUrl!)">
                </div>
                <div class="accessory-observations" *ngIf="item.Observations">
                  <small><i class="fas fa-comment"></i> {{ item.Observations }}</small>
                </div>
              </div>
            </div>
            </div>
          </div>
          <ng-template #noAccessories>
            <div class="empty-accessories">
              <i class="fas fa-tools"></i>
              <p>Nenhum acessório identificado</p>
            </div>
          </ng-template>
        </div>

        <!-- Documentos (PDF do checklist) -->
        <div *ngIf="section.SectionType === 'Document' || section.OrderIndex === 9" class="document-section-view">
          <h5 class="section-subtitle"><i class="fas fa-file-pdf"></i> Documentos do checklist</h5>
          <div *ngFor="let item of getValidItems(section.Items)" class="document-item-card">
            <div *ngIf="isPdfItem(item)" class="pdf-download-row">
              <span><i class="fas fa-file-pdf text-danger"></i> {{ item.ItemName || 'Documento Pdf' }}</span>
              <button type="button" class="btn btn-sm btn-primary" (click)="downloadPdf(item)">
                <i class="fas fa-download"></i> Baixar PDF
              </button>
            </div>
          </div>
        </div>

        <!-- Layout para Assinatura -->
        <div *ngIf="section.OrderIndex === 8 || section.SectionName === 'Assinatura do Condutor'" class="signature-section-view">
          <div class="signature-info-grid">
            <div *ngFor="let item of getValidItems(section.Items)" class="signature-item">
              <!-- Foto da Assinatura -->
              <div *ngIf="item.ItemType === 'Photo' && item.ChecklistTemplateItemId === 70" class="signature-photo-container">
                <h5><i class="fas fa-signature"></i> {{ item.ItemName }}</h5>
                <div class="signature-photo-wrapper" *ngIf="item.PhotoUrl">
                  <img [src]="item.PhotoUrl" 
                       alt="Assinatura do Condutor" 
                       class="signature-photo-display" 
                       (click)="openImageModal(item.PhotoUrl!)">
                  <div class="signature-badge">
                    <i class="fas fa-check-circle"></i> Assinatura Confirmada
                  </div>
                </div>
                <div class="signature-placeholder" *ngIf="!item.PhotoUrl">
                  <i class="fas fa-signature"></i>
                  <span>Assinatura não disponível</span>
                </div>
              </div>
              
              <!-- Dados do Condutor (texto) -->
              <div *ngIf="item.ItemType === 'Text'" class="signature-data-item">
                <div class="signature-label">
                  <i class="fas" 
                     [class.fa-user]="item.ChecklistTemplateItemId === 66"
                     [class.fa-phone]="item.ChecklistTemplateItemId === 67"
                     [class.fa-envelope]="item.ChecklistTemplateItemId === 68"
                     [class.fa-id-card]="item.ChecklistTemplateItemId === 69"></i>
                  {{ item.ItemName }}
                </div>
                <div class="signature-value">{{ item.TextValue || '-' }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Layout padrão (tabela customizada) para outros tipos -->
        <div *ngIf="section.SectionType !== 'Photos' && section.SectionType !== 'Accessories' && section.SectionType !== 'Document' && section.OrderIndex !== 8 && section.OrderIndex !== 9" class="standard-items-container">
          <div class="view-fields-grid">
            <div *ngFor="let item of getValidItems(section.Items)" class="view-field-card" [class.view-field-card--pdf]="isPdfItem(item)">
              <div class="view-field-icon" *ngIf="!isPdfItem(item)">
                <i class="fas" [ngClass]="getViewItemIcon(item)"></i>
              </div>
              <div class="view-field-body">
                <div class="view-field-label">{{ item.ItemName || '-' }}</div>
                <div class="view-field-value" *ngIf="!isPdfItem(item)">
                  <span *ngIf="item.Condition && isConditionBadgeValue(item.Condition)" class="value-badge"
                        [class.value-badge--success]="item.Condition === 'Bom' || item.Condition === 'Cheio'"
                        [class.value-badge--warning]="item.Condition === 'Médio' || item.Condition === '1/4' || item.Condition === '1/2' || item.Condition === '3/4'"
                        [class.value-badge--danger]="item.Condition === 'Ruim' || item.Condition === 'Reserva'">
                    {{ item.Condition }}
                  </span>
                  <span *ngIf="item.Condition && !isConditionBadgeValue(item.Condition)">{{ item.Condition }}</span>
                  <span *ngIf="!item.Condition && getViewItemDisplayValue(item)">{{ getViewItemDisplayValue(item) }}</span>
                  <span *ngIf="!item.Condition && !getViewItemDisplayValue(item)" class="view-field-empty">Não informado</span>
                </div>
                <div class="view-field-actions" *ngIf="isPdfItem(item)">
                  <button type="button" class="btn btn-sm btn-primary" (click)="downloadPdf(item)">
                    <i class="fas fa-download"></i> Baixar PDF
                  </button>
                </div>
                <div class="view-field-obs" *ngIf="item.Observations && !isPdfItem(item)">
                  <i class="fas fa-comment-alt"></i> {{ item.Observations }}
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="getValidItems(section.Items).length === 0" class="empty-standard-items">
            <i class="fas fa-inbox"></i>
            <p>Nenhum item nesta seção</p>
          </div>
        </div>
      </div>
      <div *ngIf="!section.Items || section.Items.length === 0 || getValidItems(section.Items).length === 0" class="empty-section">
        <i class="fas fa-inbox"></i>
        <p>Nenhum item preenchido nesta seção</p>
      </div>
    </div>
  </div>

  </div>
</div>

<!-- Modo de Edição/Criação -->
<div *ngIf="!isViewMode" class="wizard">
  <!-- Ao abrir do contrato: loading até os dados do contrato preencherem o form -->
  <app-loading *ngIf="isLoading && contractIdFrom" message="Preenchendo com dados do contrato..."></app-loading>
  <ng-container *ngIf="!isLoading || !contractIdFrom">
  <header class="wizard-header">
    <div class="wizard-title">
      <h2>{{ isEdit ? 'Editar Checklist' : 'Novo Checklist' }}</h2>
      <span class="subtitle">{{ isEdit ? 'Edite as informações do checklist' : 'Preencha as etapas para iniciar o checklist' }}</span>
    </div>
    <div class="progress">
      <div class="progress-bar" [style.width.%]="progressPercent"></div>
    </div>
  </header>

  <div class="wizard-steps steps-pill">
    <button class="step-pill" *ngFor="let s of stepMeta" [class.active]="step===s.id" (click)="goTo(s.id)">
      <span class="pill-index">{{s.id}}</span>
      <span class="pill-text">
        <span class="pill-title">{{s.title}}</span>
        <span class="pill-subtitle">{{s.subtitle}}</span>
      </span>
    </button>
  </div>

  <div class="wizard-body">
    <!-- Etapa 1 -->
    <section *ngIf="step===1" [formGroup]="vehicleForm">
      <div class="card">
        <h3 class="wizard-card-title"><span class="wizard-step-letter">A</span><i class="fas fa-motorcycle"></i> Dados do veículo</h3>
        <div class="vehicle-data-grid">
          <div class="row row-full">
            <label><i class="fas fa-id-card"></i> Placa</label>
            <div class="input-group">
              <input type="text" formControlName="plate" placeholder="ABC1D23" />
              <button class="btn" (click)="onFindVehicle()">
                <i class="fas fa-search"></i> Buscar por placa
              </button>
              <button class="btn" (click)="openCameraForPlate()" [disabled]="isLoadingPlateDetection">
                <i class="fas fa-camera" *ngIf="!isLoadingPlateDetection"></i>
                <i class="fas fa-spinner fa-spin" *ngIf="isLoadingPlateDetection"></i>
                {{ isLoadingPlateDetection ? 'Processando...' : 'Tirar foto da placa' }}
              </button>
            </div>
            <span class="helper">Digite a placa ou tire uma foto da placa para preencher automaticamente.</span>
          </div>
          
          <div class="row">
            <label><i class="fas fa-motorcycle"></i> Modelo</label>
            <input type="text" formControlName="model" placeholder="Ex: Honda CG 160 Titan" />
          </div>
        </div>
      </div>

      <div class="card">
      <h3 class="wizard-card-title"><span class="wizard-step-letter">B</span><i class="fas fa-user"></i> Condutor</h3>
      <div class="grid-3-cols">
        <div class="row">
          <label><i class="fas fa-user"></i> Nome</label>
          <input type="text" formControlName="driverName" />
        </div>
        <div class="row">
          <label><i class="fas fa-id-card"></i> CPF</label>
          <input type="text" formControlName="driverCpf" />
        </div>
        <div class="row">
          <label><i class="fas fa-phone"></i> Telefone</label>
          <input type="text" formControlName="driverPhone" />
        </div>
      </div>
      </div>
    </section>

    <!-- Etapa 2 -->
    <section *ngIf="step===2" [formGroup]="conditionsForm">
      <div class="card">
      <h3 class="wizard-card-title"><span class="wizard-step-letter">C</span><i class="fas fa-clipboard-check"></i> Condições</h3>
      <div class="row">
        <label><i class="fas fa-tachometer-alt"></i> Km painel</label>
        <input type="text" formControlName="panelKm" appNumberMask [decimals]="0" placeholder="Ex: 50.000" />
      </div>
      <div class="row-inline">
        <div>
          <label><i class="fas fa-circle"></i> Condição dos pneus</label>
          <select formControlName="tireCondition">
            <option [ngValue]="'Bom'">Bom</option>
            <option [ngValue]="'Medio'">Médio</option>
            <option [ngValue]="'Ruim'">Ruim</option>
          </select>
        </div>
        <div>
          <label><i class="fas fa-gas-pump"></i> Nível de combustível</label>
          <select formControlName="fuelLevel">
            <option [ngValue]="'reserva'">Reserva</option>
            <option [ngValue]="'1/4'">1/4</option>
            <option [ngValue]="'1/2'">1/2</option>
            <option [ngValue]="'3/4'">3/4</option>
            <option [ngValue]="'cheio'">Cheio</option>
          </select>
        </div>
        <div>
          <label><i class="fas fa-spray-can"></i> Veículo está sujo?</label>
          <select formControlName="isDirty">
            <option [ngValue]="true">Sim</option>
            <option [ngValue]="false">Não</option>
          </select>
        </div>
      </div>
      </div>
    </section>

    <!-- Etapa 3 -->
    <section *ngIf="step===3">
      <div class="card">
        <h3 class="wizard-card-title"><span class="wizard-step-letter">D</span><i class="fas fa-camera"></i> Fotos do veículo</h3>
        <p class="section-description">Tire pelo menos uma foto de cada lado do veículo</p>
        
        <div class="photos-grid">
          <div class="photo-card" *ngFor="let s of sides">
            <div class="photo-preview" [ngClass]="{empty: !photosRequired[s]}">
              <img *ngIf="photosRequired[s]" [src]="photosRequired[s]" alt="{{s | titlecase}}"/>
              <div *ngIf="!photosRequired[s]" class="empty-state">
                <i class="fas fa-camera"></i>
                <span>Sem foto</span>
              </div>
            </div>
            <div class="photo-info">
              <h4>{{s | titlecase}}</h4>
              <button class="file-input-label" type="button" (click)="openCameraForRequiredPhoto(s)">
                <i class="fas fa-camera"></i>
                <span>Tirar foto</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <h3 class="wizard-card-title"><i class="fas fa-search-plus"></i> Fotos detalhadas</h3>
        <p class="section-description">Adicione fotos específicas de danos ou problemas encontrados (até 4 por lado)</p>
        
        <div class="detail-form">
          <div class="form-row">
            <div class="form-group">
              <label>Lado do veículo</label>
              <select #side class="form-control">
                <option [ngValue]="'frente'">Frente</option>
                <option [ngValue]="'direita'">Direita</option>
                <option [ngValue]="'esquerda'">Esquerda</option>
                <option [ngValue]="'cima'">Cima</option>
                <option [ngValue]="'traseira'">Traseira</option>
              </select>
            </div>
            <div class="form-group">
              <label>Tipo de dano</label>
              <select #damage class="form-control">
                <option [value]="1">Arranhado</option>
                <option [value]="2">Amassado</option>
                <option [value]="3">Piques</option>
                <option [value]="4">Trincado</option>
                <option [value]="5">Quebrado</option>
                <option [value]="6">Falta</option>
              </select>
            </div>
            <div class="form-group">
              <label>Observação</label>
              <input #note type="text" class="form-control" placeholder="Descreva o problema..." />
            </div>
            <div class="form-group">
              <label>Foto</label>
              <button class="file-input-label" type="button" (click)="openCameraForDetailPhoto(side.value, damage.selectedOptions[0].value || damage.value, note.value)">
                <i class="fas fa-camera"></i>
                <span>Tirar foto</span>
              </button>
              <span class="helper" style="display: block; margin-top: 5px; font-size: 12px; color: #666;">
                A foto será adicionada automaticamente após captura
              </span>
            </div>
          </div>
        </div>

        <div class="detail-photos" *ngIf="photoDetails.length > 0">
          <h4>Fotos detalhadas adicionadas</h4>
          <div class="detail-grid">
            <div class="detail-item" *ngFor="let d of photoDetails; let i = index">
              <div class="detail-preview">
                <img [src]="d.url" alt="Foto detalhada" />
                <button class="remove-btn" (click)="removeDetailPhoto(i)">
                  <i class="fas fa-times"></i>
                </button>
              </div>
              <div class="detail-info">
                <span class="detail-side">{{d.side | titlecase}}</span>
                <span class="detail-damage">{{getDamageTypeLabel(d.damageType || 1)}}</span>
                <span class="detail-note" *ngIf="d.note">{{d.note}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Etapa 4 -->
    <section *ngIf="step===4" [formGroup]="accessoriesForm">
      <div class="card">
        <h3 class="wizard-card-title"><span class="wizard-step-letter">E</span><i class="fas fa-tools"></i> Acessórios / equipamentos</h3>
        <p class="section-description">(assinale: S = Sim / N = Não / A = Avariado)</p>
        
        <div class="accessories-container">
          <div class="accessory-group" *ngFor="let group of accessoryGroups">
            <h4 class="group-title">{{group.title}}</h4>
            <div class="accessory-items">
              <div class="accessory-item" *ngFor="let field of group.items">
                <label class="accessory-label">{{field.label}}</label>
                <div class="accessory-options">
                  <label class="option-label">
                    <input type="radio" [formControlName]="field.key" [value]="'S'" />
                    <span class="option-text">S</span>
                  </label>
                  <label class="option-label">
                    <input type="radio" [formControlName]="field.key" [value]="'N'" />
                    <span class="option-text">N</span>
                  </label>
                  <label class="option-label">
                    <input type="radio" [formControlName]="field.key" [value]="'A'" />
                    <span class="option-text">A</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Etapa 5 -->
    <section *ngIf="step===5" [formGroup]="observationsForm">
      <div class="card">
        <h3 class="wizard-card-title"><span class="wizard-step-letter">F</span><i class="fas fa-comment-alt"></i> Observações</h3>
        <textarea formControlName="notes" rows="6" placeholder="Observações gerais..."></textarea>
      </div>
    </section>

    <!-- Etapa 6 -->
    <section *ngIf="step===6" [formGroup]="signatureForm">
      <div class="card">
      <h3 class="wizard-card-title"><span class="wizard-step-letter">G</span><i class="fas fa-signature"></i> Assinatura do condutor</h3>
      <div class="grid-2">
        <div class="row">
          <label><i class="fas fa-user"></i> Nome</label>
          <input type="text" formControlName="name" placeholder="Nome completo do condutor" />
        </div>
        <div class="row">
          <label><i class="fas fa-id-card"></i> CPF</label>
          <input type="text" formControlName="cpf" placeholder="000.000.000-00" />
        </div>
        <div class="row">
          <label><i class="fas fa-phone"></i> Telefone</label>
          <input type="text" formControlName="phone" placeholder="(00) 00000-0000" />
        </div>
        <div class="row">
          <label><i class="fas fa-envelope"></i> E-mail</label>
          <input type="email" formControlName="email" placeholder="email@exemplo.com" />
        </div>
      </div>
      <div class="signature-section">
        <div class="signature-area">
          <div class="signature-placeholder" *ngIf="!signatureForm.value.signatureDataUrl">
            <i class="fas fa-signature"></i>
            <p>Clique no botão abaixo para assinar o documento</p>
            <button class="btn btn-primary" type="button" (click)="openSignatureModal()">
              <i class="fas fa-pen"></i> Assinar Documento
            </button>
          </div>
          <div class="signature-preview" *ngIf="signatureForm.value.signatureDataUrl">
            <div class="signature-preview-header">
              <h4><i class="fas fa-check-circle"></i> Assinatura Capturada</h4>
              <button type="button" class="btn btn-secondary" (click)="signatureForm.patchValue({signatureDataUrl: ''})">
                <i class="fas fa-times"></i> Remover
              </button>
            </div>
            <div class="signature-preview-content">
              <img [src]="signatureForm.value.signatureDataUrl" alt="Assinatura" />
            </div>
            <div class="signature-actions" style="margin-top: 15px; text-align: center;">
              <button type="button" class="btn btn-success" (click)="saveSignature()" [disabled]="isGeneratingPdf">
                <i class="fas fa-file-pdf" *ngIf="!isGeneratingPdf"></i>
                <i class="fas fa-spinner fa-spin" *ngIf="isGeneratingPdf"></i>
                {{ isGeneratingPdf ? 'Gerando PDF...' : 'Gerar PDF do Checklist' }}
              </button>
              <p *ngIf="generatedPdfBase64" class="text-success" style="margin-top: 10px; font-size: 14px;">
                <i class="fas fa-check-circle"></i> PDF gerado com sucesso! O PDF será incluído ao salvar o checklist.
              </p>
            </div>
          </div>
        </div>
      </div>
      </div>
    </section>
  </div>

  <div class="wizard-footer sticky">
    <button class="btn btn-secondary" (click)="cancelChecklist()" *ngIf="!isEdit">
      <i class="fas fa-times"></i> Cancelar
    </button>
    <button class="btn" (click)="prev()" [disabled]="step===1">
      <i class="fas fa-arrow-left"></i> Voltar
    </button>
    <button class="btn" (click)="advance()" *ngIf="step<6" [disabled]="!canAdvance(step)">
      Avançar <i class="fas fa-arrow-right"></i>
    </button>
    <button class="btn btn-primary" (click)="save()" *ngIf="step===6">
      <i class="fas fa-save"></i> Salvar Checklist
    </button>
  </div>
  </ng-container>
</div>
 </app-side-menu>



